import { render, staticRenderFns } from "./OtherDocuments.vue?vue&type=template&id=bbf0adbc&scoped=true&"
import script from "./OtherDocuments.vue?vue&type=script&lang=js&"
export * from "./OtherDocuments.vue?vue&type=script&lang=js&"
import style0 from "./OtherDocuments.vue?vue&type=style&index=0&id=bbf0adbc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbf0adbc",
  null
  
)

export default component.exports